// extracted by mini-css-extract-plugin
export default {"loginEmailPassword":"Register_loginEmailPassword__1hMCQ","formWrapper":"Register_formWrapper__HrlBM"};